import*as a from"antd/lib/message";import m from"antd/lib/message";var r=m,e=a;export{r as message,e as messageApi};
